import React from 'react'
import AttendancePage from './components/AttendancePage';



const attendance = () => {

  return (
    <React.Fragment>
       <AttendancePage></AttendancePage>
    </React.Fragment>
  )
}

export default attendance;